import { useContainer } from '@hub-la/fe-container'
import { HttpClient } from '@hub-la/fe-core-http-client'
import { useMutation } from '@tanstack/react-query'
import { UserVerificationTelegramStep } from '../../domain/enums/user-verification-telegram-step'
import { UpdateVerificationTelegramStepUseCase } from '../../usecases/update-verification-telegram-step.usecase'

export const useUpdateVerificationTelegramStep = () => {
  const container = useContainer()

  const { isError, error, isLoading, data, mutateAsync, isSuccess } = useMutation(
    (step: UserVerificationTelegramStep) =>
      new UpdateVerificationTelegramStepUseCase(container.get(HttpClient)).execute(step),
    {},
  )

  return {
    isError,
    error,
    data,
    isLoading,
    isSuccess,
    mutateAsync,
  }
}
